<app-document-signer-notifications
  *ngIf="notifyType === 'signer'"
  [form]="form.get('signer')"
></app-document-signer-notifications>
<app-document-user-notifications
  *ngIf="notifyType === 'user'"
  [form]="form.get('sender')"
  [receiverForm]="reminderForm"
></app-document-user-notifications>
